import Table from 'components/Table/Table';
import TableSkeleton from 'components/Table/TableSkeleton/TableSkeleton';
import { UNAUTHORIZED } from 'constants';
import { selectAuthUser } from 'features/auth/authSlice';
import { useDeleteDIDMutation, useGetDIDsByExtensionQuery } from 'features/did/didApiSlice';
import { setNavbarTitle } from 'features/navbar/navbarSlice';
import React, { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { RiArrowRightSLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import cardStyles from "styles/modules/Card.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";
import { actions } from 'utils/helpers';
import { Globals } from 'utils/styleconfig';

const ExtensionDIDs = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authUser = useSelector(selectAuthUser);

  const { currentData, isLoading, isError, error } = useGetDIDsByExtensionQuery(
    params?.id,
    {
      selectFromResult: ({ currentData, isError, isLoading }) => ({
        isError,
        isLoading,
        currentData,
      }),
    }
  );

  const [deleteDID] = useDeleteDIDMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Extension DIDs"));
  }, [dispatch]);

  const [errorDisplayed, setErrorDisplayed] = useState(false);

  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || "Could not load extension dids, try refreshing the page");
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);


  let buttonEl = null;

  const onItemClickHandler = (id) => {
    const selectedDID = currentData?.entities[id];
    if (selectedDID) {
      navigate(`/dids/${selectedDID.did_id}`);
    }
  };

  const onDeleteHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteDID({
            extensionId: params?.id,
            didId: id,
          }).unwrap();
        }
        return "";
      }
      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteDID, label, params?.id]
  );

  const onAddBtnHandler = useCallback(() => {
    if (authUser?.actions[label].includes(actions.create)) {
      navigate(`/extensions/${params.id}/assign_did`);
    }
  }, [authUser?.actions, label, navigate, params?.id]);

  if (authUser?.actions[label].includes(actions.create)) {
    buttonEl = (
      <button
        onClick={onAddBtnHandler}
        className={utilityStyles.outline__button}
      >
        <span>Assign DID to Extension</span>
        <RiArrowRightSLine color={Globals.colorDarkBlue} size={16} />
      </button>
    );
  }

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for extension DIDs</h3>
        <div
          className={`${utilityStyles.flexRow} ${utilityStyles.itemsCenter}`}
        >
          {buttonEl}
        </div>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Table
          data={currentData}
          onItemClickHandler={onItemClickHandler}
          onDelete={onDeleteHandler}
        />
      )}
    </div>
  )
}

export default ExtensionDIDs